import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import LockFingerprint from 'src/assets/img/LockFingerprint.png'

import Login from 'src/ui/templates/Login'
import Button from 'src/ui/atoms/Button'

import useVerifyAccountApi from './useVerifyAccountApi'

const ForgotPassword = () => {
  const navigate = useNavigate()
  const { verifyAccount } = useVerifyAccountApi()
  const [isVerified, setIsVerified] = useState(false)
  const [verificationFailed, setVerificationFailed] = useState(false)

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const email = queryParams.get('email')
  const verificationCode = queryParams.get('code')

  useEffect(() => {
    const verifyAccountAction = async () => {
      if (email && verificationCode) {
        try {
          const response: any = await verifyAccount({ email, verificationCode })

          if (response?.data?.success) {
            setIsVerified(true)
          } else {
            setVerificationFailed(true)
          }
        } catch (err) {
          console.error('Account verification error', err)
          setVerificationFailed(true)
        }
      }
    }
    if (!isVerified) {
      verifyAccountAction()
    }
  }, [])

  let verificationText = ''
  if (email && verificationCode && !verificationFailed) {
    if (isVerified) {
      verificationText += 'Your account has been verified.'
    } else {
      verificationText += 'We are verifying your account'
    }
  } else {
    verificationText = 'Something went wrong. Please try again.'
  }

  return (
    <Login leftContent={LockFingerprint}>
      <div className="grid h-full content-center gap-6 text-center">
        <h1 className="text-center text-white">Account verification</h1>
        {!verificationFailed && (
          <span className="text-center text-lg text-white">
            You're almost ready to start enjoying ZoidCore.
          </span>
        )}
        <span className="text-center text-lg text-white">{verificationText}</span>
        <Button name="Go back to Login" onClick={() => navigate('/login')} />
      </div>
    </Login>
  )
}

export default ForgotPassword
